const initialState = {
  loading: false,
  error: false,
  totalFinance: 0,
  financeListing: [],
  financeDetail: null,
};

const financeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_FINANCE_REQUEST":
    case "DELETE_FINANCE_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_FINANCE_REQUEST_SUCCESS":
      return {
        ...state,
        loading: false,
        financeListing: action.payload,
        totalFinance: action.total,
        error: false,
      };

    case "GET_FINANCE_REQUEST_FAILED":
    case "DELETE_FINANCE_FAILED":
      return {
        ...state,
        loading: false,
        error: true,
      };

    case "DELETE_FINANCE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default financeReducer;
